import './analytics';
import setup from './integrations.js';

setup(window.BulldeskSettings);
